/**
 * Sanitize values from input components
 * Helpful especially for TextInputs that take only numbers etc.
 * @param str string to sanitize
 */

export const removeSpecialCharacters = (str: string): string => {
  if (str) {
    return str.replace(/[^\w\s]/gi, '')
  }
  return ''
}

export const removeCommas = (str: string): string => {
  if (str) {
    return str.replace(/,/g, '')
  }
  return ''
}
